module.exports = __webpack_public_path__ + "img/account.ad0c7a77.png";